var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddProof(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 13V5.875L3.0625 8.0625L2 7L6 3L10 7L8.9375 8.0625L6.75 5.875V13H5.25ZM0 3V1.5C0 1.0875 0.146958 0.734376 0.440875 0.440626C0.734792 0.146876 1.08811 0 1.50083 0H10.5059C10.9186 0 11.2708 0.146876 11.5625 0.440626C11.8542 0.734376 12 1.0875 12 1.5V3H10.5V1.5H1.5V3H0Z",
    fill: "#1B436E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddProof);
export default __webpack_public_path__ + "static/media/addProof.5447803ed83840334d3dfa5de014d318.svg";
export { ForwardRef as ReactComponent };